import React from 'react';
import {
  AssignmentOutlinedIcon,
  PersonAddIcon,
  TableChartIcon
} from 'icons/materialIcons';

export const LEAD_SOURCE_CONFIG = {
  'lead-capture-form': {
    label: 'Lead capture form',
    color: '#607D8B',
    icon: <AssignmentOutlinedIcon />
  },
  'csv-import': {
    label: 'Import via CSV',
    color: '#00ACC1', // Cyan color
    icon: <TableChartIcon />
  },
  'manually-added': {
    label: 'Manually Added',
    color: '#3F51B5', // Indigo color
    icon: <PersonAddIcon />
  }
};

export const DEFAULT_LEAD_SOURCE = 'manually-added';